import {Component, OnDestroy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {
  ClearState,
  FetchGroupDetailsRequest
} from '../core/group-details.actions';
import {Store} from '@ngrx/store';
import {duplicateGroup, groupDetails} from '../core/group-details.selector';
import {Subject, takeUntil} from 'rxjs';
import {GroupDetailsService} from "../core/group-details.service";

@Component({
  selector: 'app-container',
  templateUrl: './group-details-screen-container.component.html',
  styleUrls: ['./group-details-screen-container.component.css']
})
export class GroupDetailsScreenContainerComponent {
  displayGroupsScreen: boolean = true;
  groupId: string;
  startDateTime: string = null;
  payload: any;
  sessionEditable = false;
  clientId: string;
  resetSessionsList = false;
  groupDetails: any;
  groupDetailsLoader: boolean = false;
  duplicateGroupLoader: boolean = false;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private groupDetailsService: GroupDetailsService,
  ) {

    this.groupId = this.route.snapshot.paramMap.get('groupId');
    if (this.groupId) {
      const payload = {
        groupId: this.groupId,
      };
      this.store.dispatch(FetchGroupDetailsRequest({payload}));

      this.store.select(groupDetails)
        .pipe(takeUntil(this.onDestroy))
        .subscribe(data => {
          this.groupDetailsLoader = data?.loading
          if (!data || !data?.details) {
            return;
          }
          this.groupDetails = data.details;

          this.clientId = data?.details?.clientId;

          // once group details got
          if (this.route?.snapshot?.paramMap?.get('sessionId') || this.route?.snapshot?.queryParamMap?.get('reSchedule')) {
            this.displayGroupsScreen = false;
            this.sessionEditable = true;
          }
        });
    }

    this.groupDetailsService
      .disableForm
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        this.sessionEditable = false;
        this.resetSessionsList = false;
      });

    this.store.select(duplicateGroup).pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.duplicateGroupLoader = data?.loading;
      });
  }

  changeResetSessionsList(flag) {
    this.resetSessionsList = flag;
  }

  toggleButtonClicked(data) {
    this.sessionEditable = this.resetSessionsList;
    this.displayGroupsScreen = !!data;
  }

  onPrevious(data) {
    this.displayGroupsScreen = true;
  }

  onContinue(data) {
    this.sessionEditable = true;
    this.payload = data;
    this.startDateTime = data?.startDate.toISOString()
    this.displayGroupsScreen = false;
    this.resetSessionsList = this.groupDetails?.startDateTime && this.startDateTime !== this.groupDetails.startDateTime || true;
  }
}
